import { createRoute } from "@tanstack/react-router";
import { RootRoute } from "./__root";
import HomePage from "../pages/HomePage";
import EngagementHomePage from "../pages/EngagementHomePage";
import PayrollModulePage from "../pages/PayrollModulePage";
import RommLibraryPage from "../pages/RommLibraryPage";
import LoginPage from "../pages/LoginPage";
import ClientSelectionPage from "../pages/ClientSelectionPage";
import EngagementSelectionPage from "../pages/EngagementSelectionPage";

// TODO: Steps to add a new route:
// 1. Create a new page component in the '../pages/' directory (e.g., NewPage.tsx)
// 2. Import the new page component at the top of this file
// 3. Define a new route for the page using createRoute()
// 4. Add the new route to the routeTree in RootRoute.addChildren([...])
// 5. Add a new Link in the navigation section of RootRoute if needed

// Example of adding a new route:
// 1. Create '../pages/NewPage.tsx'
// 2. Import: import NewPage from '../pages/NewPage';
// 3. Define route:
//    const NewRoute = createRoute({
//      getParentRoute: () => RootRoute,
//      path: '/new',
//      component: NewPage,
//    });
// 4. Add to routeTree: RootRoute.addChildren([HomeRoute, NewRoute, ...])
// 5. Add Link: <Link to="/new">New Page</Link>

export const LoginRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/login",
  component: LoginPage,
});

export const EngagementHomeRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/",
  component: EngagementHomePage,
});

export const EngagementDetailRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/engagement/$engagementId",
  component: HomePage,
});

export const PayrollModuleRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/payroll/$moduleId",
  component: PayrollModulePage,
});

export const RommLibraryRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/romm-library",
  component: RommLibraryPage,
});

export const ClientSelectionRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/clients",
  component: ClientSelectionPage,
});

export const EngagementSelectionRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: "/engagements",
  component: EngagementSelectionPage,
  validateSearch: (search: Record<string, unknown>): { clientId?: string } => {
    return {
      clientId: typeof search.clientId === 'string' ? search.clientId : undefined,
    };
  },
});

export const rootTree = RootRoute.addChildren([
  LoginRoute,
  EngagementHomeRoute,
  EngagementDetailRoute,
  PayrollModuleRoute,
  RommLibraryRoute,
  ClientSelectionRoute,
  EngagementSelectionRoute,
]);
